module.exports = __webpack_public_path__ + "img/section8_3.c81aeb70.jpg";